export default __webpack_public_path__ + "static/media/alliedHangers2.8846998a.jpg";